import clsx from "clsx";
import { useMediaQuery } from "react-responsive";
import { BackgroundVideoPlayer } from "../BackgroundVideoPlayer";
import Lottie from "lottie-react";
import animation1 from "../../assets/lotties/collateral1.json";
import animation2 from "../../assets/lotties/collateral2.json";

const NewSlide1 = () => {
  const isMobile = useMediaQuery({ maxWidth: 640 });

  return (
    <section className="relative h-screen snap-start">
      <div className="relative">
        <div className="h-screen w-full">
          <BackgroundVideoPlayer
            webMVideo={
              isMobile ? `/videos/new-slide1.mp4` : `/videos/new-slide1.mp4`
            }
            mp4Video={
              isMobile ? `/videos/new-slide1.mp4` : `/videos/new-slide1.mp4`
            }
            videoOptions={{
              className: "h-full w-full object-cover",
            }}
          />
        </div>

        <div
          className={clsx(
            " w-full absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center z-20 xl:scale-90 xl:px-0"
            // isMobile ? "top-[320px]" : "top-[252px]"
          )}
        >
          <img
            src="/images/powered-by.png"
            alt="Background"
            className="h-8 w-auto mb-6"
          />

          <div className="font-stxihei text-white text-[20px] xl:text-6xl font-normal mb-16">
            Trade Any Market with up to 50x
            <br /> leverage using{" "}
            <span className=" text-main">HyperNative</span> Assets
            <div className="w-full h-full xl:hidden mt-6 flex justify-center ">
              <button className="bg-greyscale-text-primary font-noto-sans-thai h-full text-surface-primary text-base py-4 font-semibold flex flex-col items-center justify-center w-72 cursor-not-allowed">
                Launching on HyperEVM soon
              </button>
            </div>
          </div>

          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-4">
              <span className="text-white text-[14px] xl:text-2xl font-normal font-stxihei leading-tight">
                Use Any Collateral
              </span>
              <Lottie
                animationData={animation1}
                className=" scale-150 xl:scale-100"
              ></Lottie>
            </div>

             <div className="flex flex-col gap-4">
              <span className="text-white text-[14px] xl:text-2xl font-normal font-stxihei leading-tight">
                To Trade Any Market
              </span>
              <Lottie
                animationData={animation2}
                className=" scale-150 xl:scale-100"
              ></Lottie>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewSlide1;
